import React from 'react';
import Skeleton from '../Skeleton/Skeleton';
import styles from './TreeAndContentSkeleton.module.css';

const TreeAndContentSkeleton = () => (
  <div className={styles.treeAndContentSkeleton}>
    <div className={styles.treeSkeleton}>
      <div className={styles.treeHeaderSkeleton}>
        <Skeleton width="150px" height="14px" />
        <Skeleton width="100px" height="30px" />
      </div>
      <div className={styles.treeBodySkeleton}>
        <Skeleton width="100%" height="30px" />
        <Skeleton width="100%" height="30px" />
        <Skeleton width="100%" height="30px" />
        <Skeleton width="100%" height="30px" />
        <Skeleton width="100%" height="30px" />
        <Skeleton width="100%" height="30px" />
        <Skeleton width="100%" height="30px" />
        <Skeleton width="100%" height="30px" />
        <Skeleton width="100%" height="30px" />
      </div>
    </div>
    <div className={styles.contentSkeleton}>
      <div className={styles.toolbarSkeleton}>
        <Skeleton width="26px" height="26px" borderRadius="50%" />
        <Skeleton width="26px" height="26px" borderRadius="50%" />
        <Skeleton width="26px" height="26px" borderRadius="50%" />
      </div>
      <Skeleton width="100%" height="100%" />
    </div>
  </div>
);

export default TreeAndContentSkeleton;
